import styled from 'styled-components';

const PRODUCT_ENV_IMG_URL = 'https://res.cloudinary.com/prod/image/upload/Illustration.svg';
const ADD_USER_IMG_URL = 'https://res.cloudinary.com/prod/image/upload/upgrade-popup-modal/congratsstar.svg';

const Illustration = styled.img`
  width: 316px;
  height: 523px;
`;

interface UpgradeImageProps {
  modelPopupKind: 'addProductEnvModal' | 'addUserModal';
}
export const UpgradeImage = ({ modelPopupKind }: UpgradeImageProps) => {
  const imgUrls = {
    addProductEnvModal: PRODUCT_ENV_IMG_URL,
    addUserModal: ADD_USER_IMG_URL,
  };
  return <Illustration data-testid="upgrade-modal-image" src={imgUrls[modelPopupKind]} />;
};
